<template>
  <div class="vx-row">
    <div class="vx-col w-full">
      <vs-row vs-type="flex" vs-justify="space-between">
        <vs-col :key="1" vs-type="flex" vs-justify="left" vs-align="right" vs-w="2">
          <vs-icon :icon="icon" size="large" :color="color" />
        </vs-col>
        <vs-col :key="2" vs-type="flex" vs-justify="right" vs-align="right" vs-w="10">
          <div class="truncate" align="right">
            <h2 class="mb-1 font-bold">
              {{ summary }}{{ suffix }}
            </h2>
            <span>{{ title }}</span>
          </div>
        </vs-col>
      </vs-row>
      <b-overlay :show="dataLoading" spinner-variant="primary" variants="white" opacity="0.6">
        <apex-charts
          ref="chart"
          type="area"
          height="150"
          :options="barChart.chartOptions"
          :series="barChart.series"
        />
      </b-overlay>
    </div>
  </div>
</template>

<script>
import ApexCharts from 'vue-apexcharts'

export default {
  components: {
    ApexCharts,
  },
  props: ['graphsDataColumn', 'graphsData', 'color', 'title', 'tooltip', 'icon', 'suffix', 'dataLoading'],
  data() {
    return {
      summary: 0,
      barChart: {
        series: [{
          name: '',
          data: [],
        }],
        chartOptions: {
          chart: {
            id: this.graphsDataColumn,
            group: 'social',
            toolbar: false,
            enabled: false,
          },
          xaxis: {
            type: 'category',
            categories: [],
            labels: {
              show: false,
            },
            axisBorder: {
              show: false,
            },
            axisTicks: {
              show: false,
            },
            crosshairs: {
              show: false,
            },
            tooltip: {
              enabled: false,
            },
          },
          yaxis: {
            labels: {
              show: false,
              minWidth: 1,
            },
          },
          colors: [this.color, '#28C76F', '#EA5455', '#FF9F43', '#21373f'],
          plotOptions: {
            bar: {
              horizontal: true,
            },
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'smooth',
          },
          grid: {
            show: false,
          },
          legend: {
            show: false,
          },
          fill: {
            gradient: {
              enabled: true,
              opacityFrom: 0.55,
              opacityTo: 0,
            },
          },
          markers: {
            size: 0,
          },
        },
      },
    }
  },
  watch: {
    graphsData() {
      this.reloadData()
    },
    dataLoading() {
      return this.dataLoading
    },
  },
  methods: {
    formatToolTip(item) {
      if (item.period_start !== item.period_end) {
        return `${item.period_start} - ${item.period_end}`
      }
      return item.period_start
    },
    reloadData() {
      const series = []
      const axis = []

      for (let i = 0; i < this.graphsData.data.length; i++) {
        const item = this.graphsData.data[i]
        series.push(item[this.graphsDataColumn])
        axis.push(this.formatToolTip(item))
      }

      this.barChart.series = [{
        data: series,
        name: this.tooltip,
      }]

      this.summary = this.graphsData.summary[this.graphsDataColumn]
      this.barChart.chartOptions.xaxis.categories = axis
      this.$refs.chart.refresh()
    },
  },
}
</script>
